/**
 * Web: React Native Image `alt` maps to HTML img[alt] (Lighthouse / WCAG).
 * Use empty string for decorative icons (coins, effects) per WCAG.
 */
export const WEB_IMAGE_ALT_DECORATIVE = '';

export const WEB_IMAGE_ALT_AVATAR_DEFAULT = 'Avatar';

export function webImageAltAvatarLabel(nameForInitials: string | undefined): string {
  const n = nameForInitials?.trim();
  return n ? `Avatar for ${n}` : WEB_IMAGE_ALT_AVATAR_DEFAULT;
}

export function webImageAltGroupCover(groupName: string): string {
  const n = groupName.trim();
  return n ? `Group cover: ${n}` : 'Group cover image';
}

export function webImageAltProfilePhoto(displayName: string | undefined): string {
  const n = displayName?.trim();
  return n ? `Profile photo for ${n}` : 'Profile photo';
}

export function webImageAltTeamLogo(teamLabel: string | undefined): string {
  const n = teamLabel?.trim();
  return n ? `${n} logo` : 'Team logo';
}

export function webImageAltDailyRewardCoins(amount: number): string {
  return `${amount} coin reward`;
}

export function webImageAltTutorialIllustration(slideTitle: string): string {
  return `Tutorial illustration: ${slideTitle}`;
}

/** Default when PhoneMockup is used without a slide title. */
export const WEB_IMAGE_ALT_TUTORIAL_DEFAULT = 'Tutorial illustration';
